export enum FilterSectionsLayoutBlock {
  Root = 'FilterSectionsLayout',
}
